export default "/images/search.svg?52530b39fa626575e6e025ebace91c2a";